import { mainColor } from "assets/styleUtils";
import * as React from "react";

const SvgLogo = (props) => (
  <svg
    width="57"
    height="57"
    viewBox="0 0 57 57"
    fill={mainColor}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.464844"
      y="0.882812"
      width="55.8711"
      height="55.8711"
      rx="11.3213"
    />
    <g opacity="0.9">
      <path
        d="M28.3977 12.4634C19.0791 12.4634 11.5078 19.7942 11.5078 28.8167C11.5078 37.8392 19.0791 45.17 28.3977 45.17C37.7162 45.17 45.2875 37.8392 45.2875 28.8167C45.2875 19.7942 37.7162 12.4634 28.3977 12.4634ZM25.3268 43.0682L36.4455 32.3027V41.0945C34.1158 42.5299 31.3626 43.3502 28.4241 43.3502C27.3652 43.3502 26.3327 43.2476 25.3532 43.0426L25.3268 43.0682ZM38.2721 39.7873V30.1752L36.7102 29.56L23.3148 42.5299C22.2824 42.1711 21.3029 41.7097 20.4028 41.1458V32.3283L25.0091 36.7883L26.3063 35.5323L20.138 29.56L18.5761 30.1752V39.8129C15.3994 37.1472 13.3609 33.1998 13.3609 28.8167C13.3609 20.7938 20.1116 14.2576 28.3977 14.2576C36.6837 14.2576 43.4344 20.7938 43.4344 28.8167C43.4344 33.1998 41.4224 37.1215 38.2457 39.8129L38.2721 39.7873Z"
        fill="white"
      />
      <path
        d="M33.374 18.2305H23.3936L22.7583 18.4868L18.4961 22.6136V23.8695L27.7352 32.8152H29.0324L38.2715 23.8695V22.6136L34.0093 18.4868L33.374 18.2305ZM24.7173 19.9991H32.0503L28.3705 29.6368L24.6908 19.9991H24.7173ZM23.0495 20.7168L26.0939 28.6884L20.4551 23.2287L23.0495 20.7168ZM30.7002 28.6884L33.7446 20.7168L36.339 23.2287L30.7002 28.6884Z"
        fill="white"
      />
    </g>
  </svg>
);
export default SvgLogo;
